import Articles from 'src/views/Pages/Dashboard/Supplying/Inventory/Article/Articles.vue';
import ArticlesCategories from 'src/views/Pages/Dashboard/Supplying/Inventory/ArticleCategory/ArticlesCategories.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import MasterTab from 'src/components/Layouts/MasterTab.vue';
import SupplyingUnits from 'src/views/Pages/Dashboard/Supplying/Inventory/SupplyingUnit/SupplyingUnits.vue';
import ToxicityClassifications from 'src/views/Pages/Dashboard/Supplying/Inventory/ToxicityClassification/ToxicityClassifications.vue';

const InventoryRoutes = {
  path: 'inventory',
  name: 'inventory.inventory',
  component: MasterTab,
  props: { reference: 'inventoryTabs' },
  children: [
    {
      path: 'supplyingunit',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'inventory.supplying_units',
          component: SupplyingUnits,
          meta: {
            prefix_permission: 'inventory_supplyingunit',
          },
        },
      ],
    },
    {
      path: 'articlecategory',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'inventory.article_category',
          component: ArticlesCategories,
          meta: {
            prefix_permission: 'inventory_articlecategory',
          },
        },
      ],
    },
    {
      path: 'toxicityclassification',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'inventory.toxicity_classification',
          component: ToxicityClassifications,
          meta: {
            prefix_permission: 'inventory_toxicityclassification',
          },
        },
      ],
    },
    {
      path: 'article',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'inventory.articles',
          component: Articles,
          meta: {
            prefix_permission: 'inventory_article',
          },
        },
      ],
    },
  ]
};

export default InventoryRoutes;